// RevenueSummary.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, Typography, Spin, Card, Tag, Statistic, Row, Col } from 'antd';
import { BarChartOutlined, DollarCircleOutlined } from '@ant-design/icons';
import { API_BASE_URL } from '../../utils/BaseUrl';

const { Title, Text } = Typography;

const RevenueSummary = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRevenue = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/PaymentGymPackage/revenue/summary`);
      setData(res.data);
    } catch (err) {
      console.error("Lỗi khi lấy dữ liệu doanh thu:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRevenue();
  }, []);

  // Tổng doanh thu tất cả gym
  const totalRevenue = data.reduce((sum, item) => sum + item.totalAmount, 0);

  const columns = [
    {
      title: <span style={{ color: '#FF9800', fontWeight: 600 }}>Gym ID</span>,
      dataIndex: 'gymId',
      key: 'gymId',
      align: 'center',
      render: (id) => <Tag color="orange" style={{ fontSize: 15, fontWeight: 500 }}>{id}</Tag>
    },
    {
      title: <span style={{ color: '#388e3c', fontWeight: 600 }}>Tổng doanh thu (VND)</span>,
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      align: 'right',
      render: (amount) => (
        <Statistic
          value={amount}
          valueStyle={{ color: '#388e3c', fontWeight: 700, fontSize: 18 }}
          groupSeparator="."
          suffix="₫"
        />
      )
    }
  ];

  return (
    <Card
      style={{
        maxWidth: 1200,
        margin: '40px auto',
        boxShadow: '0 8px 32px #ff980033',
        borderRadius: 18,
        background: 'linear-gradient(135deg, #fffbe7 0%, #ffe0b2 100%)',
        border: 'none'
      }}
      bodyStyle={{ padding: 32 }}
    >
      <Row justify="center" align="middle" style={{ marginBottom: 24 }}>
        <Col>
          <BarChartOutlined style={{ fontSize: 36, color: '#FF9800', marginRight: 12 }} />
        </Col>
        <Col>
          <Title level={3} style={{ color: '#FF9800', margin: 0, fontWeight: 700 }}>
            Tổng Doanh Thu Theo Gym
          </Title>
        </Col>
      </Row>
      <Row justify="center" style={{ marginBottom: 24 }}>
        <Col>
          <Statistic
            title={<Text strong style={{ color: '#388e3c', fontSize: 16 }}>Tổng doanh thu toàn hệ thống</Text>}
            value={totalRevenue}
            valueStyle={{ color: '#d32f2f', fontWeight: 700, fontSize: 28 }}
            prefix={<DollarCircleOutlined />}
            groupSeparator="."
            suffix="₫"
          />
        </Col>
      </Row>
      {loading ? (
        <div style={{ textAlign: 'center', padding: 40 }}>
          <Spin size="large" />
        </div>
      ) : (
        <Table
          columns={columns}
          dataSource={data.map((item, index) => ({ ...item, key: index }))}
          pagination={false}
          bordered
          style={{ background: '#fff', borderRadius: 12, overflow: 'hidden' }}
        />
      )}
    </Card>
  );
};

export default RevenueSummary;
